import { Link, Stack, StackProps, Typography } from '@mui/material'
import {
  ArrowDropDown as DownIcon,
  ArrowDropUp as UpIcon,
} from '@mui/icons-material'
import { useEffect, useState } from 'react'

type LimittedStackProps<T> = {
  keyPrefix: string
  list: T[]
  count: number
  outerProps?: StackProps
  record: (data: T, i: number, array: T[]) => React.JSX.Element
} & StackProps
export const LimittedStack = <T,>({
  list,
  count,
  outerProps,
  record,
  ...others
}: LimittedStackProps<T>) => {
  const [allShow, setAllShow] = useState<boolean>(false)
  useEffect(() => setAllShow(false), [list])
  return (
    <Stack direction="column" spacing={0.5} {...outerProps}>
      <Stack {...others}>
        {(allShow !== false ? list : list.slice(0, count)).map((r, i) =>
          record(r, i, list)
        )}
        {(list.length > count) && (
          <Link variant="caption" underline="hover" onClick={() => setAllShow(allShow ? false : true)}>
            <Stack paddingLeft="1rem" direction="row" alignItems="center">
              {allShow ? <UpIcon fontSize="small"/> : <DownIcon fontSize="small"/>}
              <Typography variant="inherit" component="span">
                {allShow ? "閉じる" : `すべて表示 (${list.length} 件)`}
              </Typography>
            </Stack>
          </Link>
        )}
      </Stack>
    </Stack>
  )
}